function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("defs", null, React.createElement("style", null, "\n            .frame,.primary{fill:none;}.white{fill:#fff;}.highlights{fill:#e8dbec;}.primary{stroke:#4f4954;stroke-linecap:round;stroke-linejoin:round;stroke-width:16px;}\n        "));
var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "white"
}, React.createElement("path", {
  className: "white",
  d: "M202.34,33.31a15.48,15.48,0,1,1,28.38,12.36L179.4,164,155,181.46,151,151.62Z"
}));
var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "primary"
}, React.createElement("path", {
  className: "primary",
  d: "M202.34,33.31a15.48,15.48,0,1,1,28.38,12.36L179.4,164,155,181.46,151,151.62Z"
}), React.createElement("path", {
  className: "primary",
  d: "M24,224s12-24,24-24,12,24,24,24,18-18,18-18,12,18,24,18,24-24,24-24"
}));
var _ref5 = /*#__PURE__*/React.createElement("g", {
  id: "highlights"
}, React.createElement("line", {
  className: "highlights",
  x1: 232,
  y1: 232,
  x2: 24,
  y2: 232
}));
var SvgSignature = function SvgSignature(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, ["svgRef", "title"]);
  return React.createElement("svg", _extends({
    viewBox: "0 0 256 256",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, React.createElement("rect", {
    width: 256,
    height: 256,
    style: {
      fill: "none"
    }
  }), _ref3, _ref4, _ref5);
};
var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgSignature, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Signature.1984806b.svg";
export { ForwardRef as ReactComponent };